module.exports = __webpack_public_path__ + "media/dashboard/assets/images/monitor-off-ba97b9b65116fc7bb98dc264a5823c2e.svg";